import React, { useState, useEffect } from 'react';
import AresNavBar from './../Layout/NavBar/NavBar'
import SideBar from '../Layout/SideBar/SideBar'
import NoAvatar from '../../assets/img/no-avatar.png'

import './index.css'
import { Col, Row, Spinner, Container } from 'react-bootstrap';

import ProfileForm from './ProfileForm';
import ProfilePlan from './ProfilePlan';
import axios from '../../services/Api'

function Profile() {
  const [loading, setLoading] = useState(true)
  const [profile, setProfile] = useState([])
  const [plan, setPlan] = useState(null)

  useEffect(() => {
    init()
    setLoading(true)
  }, []);

  async function init() {
    await getProfile();
    await getUserPlan();
  }

  /**
   * Fetch history data
   */
  async function getProfile() {
    try {
      const response = await axios.get('/api/profile');
      setProfile(response.data);
      getUserPlan(response.data)
      setLoading(false)
      return response.data;
    } catch (e) {
      console.log(e);
      setLoading(false)
    }
  }

  async function getUserPlan() {
    try {
      const response = await axios.get(`/api/plans/`);
      setPlan(response.data)
      setLoading(false)
      return response.data;
    } catch (e) {
      console.log(e);
      setLoading(false)
    }
  }

  function renderLoading() {
    return (
      <div className="center-page">
        <Spinner animation="border" />
      </div>
    )
  }

  return (
    <div className="side-content">
      <AresNavBar />
      <SideBar />
      <div className="Profile">
        <div className="bg-profile">
          <img src={NoAvatar} alt="Ares Logo" className="avatar" />
        </div>
        {loading ?
          renderLoading()
          :
          <Container fluid>
            <div className="desktop-form">
              <ProfileForm data={profile} />
            </div>
            <div className="mobile-form">
              <ProfileForm data={profile} />
            </div>
          </Container>
        }
      </div>
    </div>
  );
}

export default Profile;